import React from 'react'
import { ColorIndicator, Description } from './styles'
import { message } from '~/services'
import { Inline, theme } from '~/styles'

export const CheckUpStatusDescription = (): JSX.Element => {
  return (
    <Inline gap="0.75rem">
      <Inline gap="0.25rem">
        <ColorIndicator color={theme.colors.colore6f4e7} />
        <Description>{message('analyticalModels.normal_status')}</Description>
      </Inline>

      <Inline gap="0.25rem">
        <ColorIndicator color={theme.colors.colorFFE2E2} />
        <Description>{message('analyticalModels.altered_status')}</Description>
      </Inline>
    </Inline>
  )
}
